import nearestPoint from '@turf/nearest-point';

import debug from 'utils/debug';

const { PROFILER } = debug('utils:nearest-point');

export default function find(target, points) {
  return PROFILER('find', () => nearestPoint(target, points));
}
